class Admin {

    /**
     * @since 4.5.4
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.ready          = false;
        this.disabledBlocks = ['core/separator'];
        this.blockStyles    = [
            {
                block:  'core/separator',
                styles: [
                    {
                        'name':  'align',
                        'label': 'Alignment'
                    }
                ]
            }
        ];

        // Force jQuery
        if ($ !== jQuery)
            $ = jQuery;

        // Run initialization
        this.init()

        // Run ACF initialize
        this.acfInit();
    }

    /**
     * Initialize Advanced Custom Fields routines.
     *
     * @since 4.75.0
     * @method acfInit
     * @return void
     * @todo Refactor this to use less generic means of sensing changes
     */
    acfInit() {
        // If we don't have it, do nothing
        if (typeof acf === 'undefined')
            return;

        // Declare and initialize
        var target               = document.getElementById('editor');
        var compareBlockSelector = '[data-type="acf/ll4-compare-table"]';

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver((mutations, observer) => {

            // Declare and initialize
            var block = $(target).find(compareBlockSelector);
            var run   = false;

            // Do nothing if the block is not there
            if (!block.length)
                return;

            // See if we have any relevant mutations
            for (const mutation of mutations) {

                // See if this within a Compare Table block
                if ($(mutation.target).closest(compareBlockSelector).length) {

                    // We are going to run the update
                    run = true;

                    // Get out of here
                    break;

                }

            }

            // If we are not running an update, do nothing
            if (!run)
                return;

            // Run updates on all Compare Table blocks
            block.each(function (index, element) {

                // Declare and initialize
                let id     = $(this).attr('id');
                let levels = $(this).find('[data-key="field_63bda896d6874"]');
                let feats  = $(this).find('[data-key="field_63bda8cbd6876"]');
                let count  = levels.find('.acf-row:not(.acf-clone)').length;
                let avail  = feats.find('[data-key="field_63bda8e5d6878"]');

                // Show them all first
                avail.find('li').show();

                // Hide some of them
                avail.find('li:gt(' + (count - 1) + ')').hide();

            });

        });

        // If there is no target there is nothing to observe
        if (!target)
            return;

        // Start observing the target node for configured mutations
        observer.observe(target, {childList: true, subtree: true});
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 4.5.4
     * @returns object The initialized map
     */
    init() {
        // Run some auto-closers
        if ($('#acf-group_68752107b9c48').length)
            $('#acf-group_68752107b9c48').addClass('closed');

        // Additional auto-closing
        if ($('#acf-group_l2ijx0ulzqw29').length) {

            // Hide our advanced custom fields
            let advanced  = $('#acf-group_l2ijx0ulzqw29');
            let container = advanced.find('.acf-fields');
            let trigger   = advanced.find('[data-bs-toggle="collapse"]');
            let target    = trigger.data('bs-target').replace('#', '');

            // Add our class to apply Bootstrap styles
            advanced.addClass('lala-theme-5');

            // Set up our container class
            container
                .removeClass('inside').addClass('collapse')
                .attr('id', target)
                .find('> .acf-field')
                .css('paddingLeft', '0');

            // Move the trigger
            trigger.prependTo(advanced);

        }

        // See if we are OK to continue
        if (!this.getReady())
            return;
    }

    /**
     * De-register default blocks that were registered client-side.
     *
     * @since 4.5.4
     * @method deregisterBlocks
     * @return voic
     */
    deregisterBlocks() {
        // Wait (again) for the WP DOM to be ready
        wp.domReady(() => {

            // Run through our disabled blocks to deregister them
            this.disabledBlocks.map((b, i) => {

                // De-register the block
                wp.blocks.unregisterBlockType(b);

            });

        });

    }

    /**
     * Perform a number of checks to see if we are ready to continue.
     *
     * @since 4.5.4
     * @method getReady
     * @return bool Flag indicating whether or not we are ready to proceed
     */
    getReady() {
        // If there is no WP object, bail
        if ('object' !== typeof wp || !wp) return false;

        // If the blocks module is not available, bail
        if (!('blocks' in wp)) return false;

        // If the unregister method id missing, bail
        if (!('unregisterBlockType' in wp.blocks)) return false;

        // If the method is uncallable, bail
        if ('function' !== typeof wp.blocks.unregisterBlockType) return false;

        // Set the flag for later use
        this.ready = true;

        // Return the immediate result
        return true;
    }

    /**
     * Register additional controls for existing blocks.
     *
     * @since 4.5.4
     * @method registerBlockStyles
     * @return void
     */
    registerBlockStyles() {
        // Run through our custom styles
        this.blockStyles.map((b, i) => {

            // Store the block name
            let block = b.block;

            // Bail out if no block is supplied
            if (!block) return;

            // Run through the styles
            b.styles.map((style, i) => {

                // Run the registration
                console.log(wp.blocks.registerBlockStyle(block, {
                    name:  style.name,
                    label: style.label
                }));

            });

        });
    }
}

export default Admin;